import React, { useState } from "react";
import { useMalware } from "../../../context/Dashboard/contextMalware";
import { useThemeMode } from "../../../context/contextTheme";
import hexToRGBA from "../../../utils/hexToRGBA";
import ScanDetailModal from "../scan/scan-details.jsx";

const Report = () => {
  const { theme } = useThemeMode();
  const { malAssets, setActiveView } = useMalware();
  const [selectedAsset, setSelectedAsset] = useState(null);
  const fileAssets = (malAssets || []).filter((item) => item.asset_type === "file");
  const urlAssets = (malAssets || []).filter((item) => item.asset_type === "url");
  console.log("malwareAssets:",malAssets);
  const calculateTotals = (assets) => {
    return assets.reduce(
      (acc, item) => {
        const statusData = item.status || {};
        acc.malicious += (statusData.malicious || 0);
        acc.harmless += (statusData.harmless || 0);
        acc.suspicious += (statusData.suspicious || 0);
        return acc;
      },
      { malicious: 0, harmless: 0, suspicious: 0 }
    );
  };

  const fileTotals = calculateTotals(fileAssets);
  const urlTotals = calculateTotals(urlAssets);
  const renderStats = (title, totals) => (
    <div className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <span
          className="badge rounded-pill me-2"
          style={{ backgroundColor: hexToRGBA(theme.textColor, 0.1), color: theme.textColor, textTransform: 'uppercase', fontSize: '0.7rem' }}
        >
          {title}
        </span>
        <div className="flex-grow-1" style={{ height: '1px', background: theme.border }}></div>
      </div>

      <div className="d-flex gap-2">
        {[
          { label: "Malicious", val: totals.malicious, color: "#dc3545", bg: "rgba(220, 53, 69, 0.1)" },
          { label: "Harmless", val: totals.harmless, color: "#198754", bg: "rgba(25, 135, 84, 0.1)" },
          ...(title === "file" ? [{ label: "Suspicious", val: totals.suspicious, color: "#ffc107", bg: "rgba(255, 193, 7, 0.1)" }] : [])
        ].map((stat, i) => (
          <div
            key={i}
            className="p-2 rounded-3 text-center flex-grow-1"
            style={{ backgroundColor: stat.bg, border: `1px solid ${hexToRGBA(stat.color, 0.2)}`, minWidth: '80px' }}
          >
            <div style={{ fontSize: "0.65rem", fontWeight: "700", color: stat.color, textTransform: 'uppercase' }}>{stat.label}</div>
            <div style={{ fontSize: "1.4rem", fontWeight: "800", color: stat.color }}>{stat.val}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className="card rounded-4 h-100 shadow-sm border-0" style={{ backgroundColor: theme.background, color: theme.textColor }}>
        <div className="card-body d-flex flex-column p-4">
          {/* Header */}
          <div className="mb-2">
            <h5 className="fw-bold mb-0">Malware Insights</h5>
            <p className="small" style={{ color: theme.textMuted }}>Aggregate results from recent scans</p>
          </div>

          {/* Stats Section */}
          <div className="py-2">
            {renderStats("file", fileTotals)}
            {renderStats("url", urlTotals)}
          </div>

          {/* History Section */}
          <div className="flex-grow-1 mt-2 overflow-hidden">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="fw-bold" style={{ fontSize: '0.9rem' }}>Scan History</div>
              <div className="badge rounded-pill bg-light text-dark border" style={{ fontSize: '0.6rem' }}>Recent {malAssets?.length || 0}</div>
            </div>

            <div className="pe-1" style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {(malAssets || [])
                .sort((a, b) => new Date(b.scan_time) - new Date(a.scan_time))
                .slice(0, 6)
                .map((asset, index) => (
                  <div
                    className="d-flex flex-row align-items-center rounded-3 p-2 mb-2 border history-row-item"
                    style={{
                      fontSize: 12,
                      backgroundColor: hexToRGBA(theme.background, 0.5),
                      borderColor: theme.border,
                      cursor: "pointer",
                      transition: 'all 0.2s ease'
                    }}
                    key={index}
                    onClick={() => setSelectedAsset(asset)} 
                  >
                    <div
                      className="me-2 rounded-2 d-flex align-items-center justify-content-center"
                      style={{ width: '32px', height: '32px', backgroundColor: hexToRGBA(theme.textColor, 0.05) }}
                    >
                      <i className={`bi ${asset.asset_type === 'file' ? 'bi-file-earmark-lock' : 'bi-link-45deg'}`} style={{ color: theme.textMuted }}></i>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <div className="text-truncate fw-bold mb-0" style={{ maxWidth: '180px' }}>
                        {asset.dir || "Unnamed Vector Target"}
                      </div>
                      <div style={{ fontSize: '10px', color: theme.textMuted }}>
                        {new Date(asset.scan_time).toLocaleDateString()} • {new Date(asset.scan_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                    <div className="ps-2 opacity-50">
                      <i className="bi bi-chevron-right style={{ fontSize: '0.8rem' }}" />
                    </div>
                  </div>
                ))}
            </div>
          </div>

          {/* Footer Action */}
          <div className="mt-4">
            <button
              className="btn w-100 py-2 fw-bold rounded-3 shadow-sm transition-all"
              style={{
                backgroundColor: theme.textColor,
                color: theme.background,
                fontSize: '0.9rem'
              }}
              onClick={() => setActiveView("CARD")}
            >
              <i className="bi bi-arrow-repeat me-2"></i>
              Initialize New Scan
            </button>
          </div>
        </div>
      </div>

      {/* RENDER MODAL POPUP IF AN ASSET VALUE HAS BEEN CLICKED */}
      <ScanDetailModal
        activeAsset={selectedAsset}
        onClose={() => setSelectedAsset(null)}
      />

      <style>{`
         .history-row-item:hover {
            transform: translateX(3px);
            background-color: ${hexToRGBA(theme.textColor, 0.03)} !important;
         }
      `}</style>
    </>
  );
};

export default Report;